<template>
    <div class="page__content profile">
        <div class="columns">
            <div class="column is-8">
                <h2 class="page__headline">{{ $t('profile.intro.headline') }}</h2>
                <p class="page__copy">
                    {{ $t('profile.intro.copy') }}
                </p>
            </div>
        </div>

        <!--<div class="notifications">-->
            <!--<div class="notification is-success" v-if="showSuccess">-->
                <!--<button class="delete" @click.prevent="showSuccess = false"></button>-->
                <!--{{ $t('generic.saveSuccess') }}-->
            <!--</div>-->

            <!--<div class="notification is-danger" v-if="hasErrors">-->
                <!--<button class="delete" @click.prevent="hasErrors = false"></button>-->
                <!--{{ $t('generic.formError') }}-->
            <!--</div>-->
        <!--</div>-->

        <form @submit.prevent="save()">
            <div class="edit-box box-shadow">
                <div class="edit-box__section">
                    <div class="columns">
                        <div class="column is-4">
                            <label for="first_name" class="label edit-box__includes-inline-input">{{
                                $t('profile.first_name') }}</label>
                        </div>
                        <div class="column is-8">
                            <form-input id="first_name" v-model="first_name"
                                        :error="formErrors.first_name"></form-input>
                        </div>
                    </div>

                    <div class="columns">
                        <div class="column is-4">
                            <label for="last_name" class="label edit-box__includes-inline-input">{{
                                $t('profile.last_name') }}</label>
                        </div>
                        <div class="column is-8">
                            <form-input id="last_name" v-model="last_name" :error="formErrors.last_name"></form-input>
                        </div>
                    </div>

                    <div class="columns">
                        <div class="column is-4">
                            <label for="email" class="label edit-box__includes-inline-input">{{ $t('profile.email') }}</label>
                        </div>
                        <div class="column is-8">
                            <form-input id="email" v-model="email" :error="formErrors.email" :options="{ inputtype: 'email' }" autocomplete="username"></form-input>
                        </div>
                    </div>

                    <article class="message is-info" v-if="showPasswordInputs && HAS_BVCD">
                        <div class="message-header">
                            <p>{{ $t('profile.passwordNote.headline') }}</p>
                        </div>
                        <div class="message-body">
                            {{ $t('profile.passwordNote.body') }}
                        </div>
                    </article>

                    <div class="columns" v-if="showPasswordInputs">
                        <div class="column is-4">
                            <label for="password" class="label edit-box__includes-inline-input">{{
                                $t('profile.password') }}</label>
                        </div>
                        <div class="column is-8">
                            <form-input id="password" v-model="password" :error="formErrors.password" :options="{ inputtype: 'password' }" autocomplete="new-password"></form-input>
                        </div>
                    </div>

                    <div class="columns" v-if="showPasswordInputs">
                        <div class="column is-4">
                            <label for="password_repeat" class="label edit-box__includes-inline-input">{{
                                $t('profile.passwordRepeat') }}</label>
                        </div>
                        <div class="column is-8">
                            <form-input id="password_repeat" v-model="password_repeat" :error="formErrors.password" :options="{ inputtype: 'password' }" autocomplete="new-password"></form-input>
                        </div>
                    </div>

                    <div class="columns" v-if="showPasswordInputs">
                        <div class="column is-offset-4">
                            <a class="button" @click.prevent="hidePasswordFields()">{{
                                $t('profile.dontChangePassword') }}</a>
                        </div>
                    </div>

                    <div class="columns" v-if="!showPasswordInputs">
                        <div class="column is-offset-4">
                            <a class="button is-danger" @click.prevent="showPasswordFields()">{{
                                $t('profile.changePassword') }}</a>
                        </div>
                    </div>
                </div>

                <div class="edit-box__footer is-clearfix">
                    <button class="button is-primary is-pulled-left" :class="{ 'is-loading' : saving }">{{
                        $t('generic.save') }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import {Api} from '../../../api';
    import {AppModel} from '../../../models';
    import {EventBus, Tracking} from '../../../utils';
    import {FormInput} from '../../components';

    export default {
        name: 'profile',

        components: {
            FormInput
        },

        data() {
            return {
                HAS_BVCD: AppModel.hasBvcd,
                saving: false,
                formErrors: {},
                hasErrors: false,
                first_name: '',
                last_name: '',
                email: '',
                username: '',
                password: '',
                password_repeat: '',
                showPasswordInputs: false,
                showSuccess: false,
            };
        },

        computed: {
            userData() {
                let data = {
                    first_name: this.first_name,
                    last_name: this.last_name,
                    email: this.email,
                };

                if(this.showPasswordInputs) {
                    data['password'] = this.password;
                }

                return data;
            },
        },

        created() {
            EventBus.$on(EventBus.UPDATE_USER_DONE, this.onUserSaved);
        },

        beforeRouteEnter(to, from, next) {
            Api.bootstrap().then(function(response) {
                return Promise.all([response, Api.user.fetchUser()]);
            }).then(function(response) {
                next((vm) => {
                    vm.onUserFetched(response[1].body);
                });
            });
        },

        methods: {
            onUserFetched(data) {
                this.first_name = data.first_name;
                this.last_name = data.last_name;
                this.email = data.email;
                this.username = data.username;
            },

            save() {
                this.formErrors = {};
                const errorBase = 'profile.errors.password';
                if(this.showPasswordInputs) {
                    if(!this.password) {
                        this.formErrors['password'] = [this.$t(`${errorBase}.empty`)];
                    } else if(this.password !== this.password_repeat) {
                        this.formErrors['password'] = [this.$t(`${errorBase}.dontMatch`)];
                    } else if(this.password.length < 8) {
                        this.formErrors['password'] = [this.$t(`${errorBase}.tooShort`)];
                    }
                }

                this.showSuccess = false;

                if(!this.formErrors['password']) {
                    this.hasErrors = false;
                    this.saving = true;
                    Api.user.updateUser(this.userData)
                        .then((response) => {
                            if(response.ok) {
                                this.onUserSaved();
                            } else {
                                this.onError(response.body);
                            }
                        }, (response) => {
                            this.onError(response.body);
                        });
                } else {
                    this.hasErrors = true;
                }
            },

            onUserSaved(data) {
                this.saving = false;
                this.hasErrors = false;
                this.showPasswordInputs = false;
                this.showSuccess = true;
                EventBus.$emit(EventBus.SHOW_NOTIFICATION, { title: `<h3>${this.$t('generic.saveSuccessHeadline')}</h3>`, direction: 'Up', body: this.$t('generic.saveSuccess') });
                Tracking.trackEvent('Profile', 'save', 'success', null);
            },

            onError(errors) {
                this.hasErrors = true;
                this.showSuccess = false;
                this.formErrors = errors;
                EventBus.$emit(EventBus.SHOW_NOTIFICATION, { title: `<h3>${this.$t('generic.formErrorHeadline')}</h3>`, direction: 'Up', type: 'danger', body: this.$t('generic.formError') });
                Tracking.trackEvent('Profile', 'save', 'failed', null);
            },

            showPasswordFields() {
                this.showPasswordInputs = true;
                Tracking.trackEvent('Profile', 'passwordFields', 'show', null);
            },

            hidePasswordFields() {
                this.showPasswordInputs = false;
                Tracking.trackEvent('Profile', 'passwordFields', 'hide', null);
            }
        },
    };
</script>

<style lang="scss">
    @import "profile.scss";
</style>



// WEBPACK FOOTER //
// src/views/pages/profile/profile.vue